import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { useSelector } from 'react-redux'
import { Course, ExternalCourse } from 'graphqlAPI'
import { joinKeys } from 'helpers/translations.helper'
import {
  createRouteCoursePreview,
  createRouteExternalCoursePreview,
  createRouteMonitoringCourse,
  createRouteMonitoringExternalCourse,
} from 'enum/routes'
import { DropdownLoader } from 'components/ui/DropdownLoader'
import { DropdownButton, styles } from 'components/ui/DropdownButton'
import { IMainState } from 'store/states'
import { prefixTranslation } from './common'
import style from './style.module.scss'

type Data = Course | ExternalCourse

interface IProps {
  course: Data
}

const Options: React.FC<IProps> = ({ course }) => {
  const { t } = useTranslation()
  const loading = false
  const [show, setShow] = useState(false)
  const { permission } = useSelector(({ user }: IMainState) => user)

  const { id, __typename } = course
  const handleDropdownClick = (show: boolean) => {
    setShow(show)
  }

  const isAllowedToPreview =
    permission.superadmin ||
    permission.admin ||
    permission?.permissions.canManageCourses

  const isExternalCourse = __typename === 'ExternalCourse'
  return (
    <DropdownButton
      show={show}
      className={styles.actionSelect}
      alignRight
      title={<DropdownLoader loading={loading} />}
      onClick={() => handleDropdownClick(!show)}
      onToggle={() => handleDropdownClick(!show)}
    >
      <Link
        to={
          isExternalCourse
            ? createRouteMonitoringExternalCourse({ id: `${id}` })
            : createRouteMonitoringCourse({ id: `${id}` })
        }
      >
        {t(joinKeys(prefixTranslation, 'view'))}
      </Link>
      {isAllowedToPreview && !isExternalCourse && (
        <Link
          to={
            createRouteCoursePreview({ courseId: `${id}` })
          }
          className={
            course['integrationCourseLink'] ? style.optionDisabled : ''
          }
        >
          {t(joinKeys(prefixTranslation, 'preview'))}
        </Link>
      )}
    </DropdownButton>
  )
}

export default Options
